import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider, useAuth } from './contexts/AuthContext';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import ResetPassword from './pages/admin/ResetPassword';
import AdminDashboard from './pages/admin/AdminDashboard';
import EventsList from './pages/admin/EventsList';
import EventDetail from './pages/admin/EventDetail';
import AttendeesList from './pages/admin/AttendeesList';
import DashboardsList from './pages/admin/DashboardsList';
import ScanLogs from './pages/admin/ScanLogs';
import ScannerAnalytics from './pages/admin/ScannerAnalytics';
import Settings from './pages/admin/Settings';
import TasksDashboard from './pages/admin/TasksDashboard';
import BlankBadges from './pages/admin/BlankBadges';

// Scanner Pages
import ScannerLogin from './pages/scanner/ScannerLogin';
import ScannerDashboard from './pages/scanner/ScannerDashboard';

import './App.css';

// Protected Route for Admin
const AdminRoute = ({ children }) => {
  const { admin, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  if (!admin) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Navigate to="/admin/login" replace />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      
      {/* Scanner Routes */}
      <Route path="/scanner" element={<ScannerLogin />} />
      <Route path="/scanner/login" element={<ScannerLogin />} />
      <Route path="/scanner/dashboard" element={<ScannerDashboard />} />
      
      {/* Admin Protected Routes */}
      <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      <Route path="/admin/events" element={<AdminRoute><EventsList /></AdminRoute>} />
      <Route path="/admin/events/:eventId" element={<AdminRoute><EventDetail /></AdminRoute>} />
      <Route path="/admin/events/:eventId/attendees" element={<AdminRoute><AttendeesList /></AdminRoute>} />
      <Route path="/admin/events/:eventId/dashboards" element={<AdminRoute><DashboardsList /></AdminRoute>} />
      <Route path="/admin/events/:eventId/scan-logs" element={<AdminRoute><ScanLogs /></AdminRoute>} />
      <Route path="/admin/events/:eventId/analytics" element={<AdminRoute><ScannerAnalytics /></AdminRoute>} />
      <Route path="/admin/events/:eventId/blank-badges" element={<AdminRoute><BlankBadges /></AdminRoute>} />
      <Route path="/admin/settings" element={<AdminRoute><Settings /></AdminRoute>} />
      <Route path="/admin/tasks" element={<AdminRoute><TasksDashboard /></AdminRoute>} />
      
      {/* 404 */}
      <Route path="*" element={<Navigate to="/admin/login" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
